var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProjectBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_project_blue"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_project_blue",
    clipPath: "url(#clip-icon_project_blue)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3643",
    "data-name": "Group 3643",
    transform: "translate(-143.615 -212.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    d: "M0-.5H4.732a.5.5,0,0,1,.5.5V14.4a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5ZM4.232.5H.5V13.9H4.232Z",
    transform: "translate(153.249 217.575)",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M166.286,232.474H144.944a.5.5,0,0,1-.354-.854l.763-.763a4.693,4.693,0,0,0,1.384-3.34,9.171,9.171,0,0,1,6.366-8.767.5.5,0,0,1,.292.956,8.164,8.164,0,0,0-5.658,7.811,5.684,5.684,0,0,1-1.588,3.957H165.08a5.77,5.77,0,0,1-1.588-3.957,8.164,8.164,0,0,0-5.657-7.811.5.5,0,1,1,.292-.956,9.171,9.171,0,0,1,6.365,8.767,4.76,4.76,0,0,0,1.384,3.341l.764.763a.5.5,0,0,1-.353.854Z",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M6.094.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H6.094a.5.5,0,0,1,.5.5A.5.5,0,0,1,6.094.5Z",
    transform: "translate(147.155 228.423)",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M6.1.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H6.1a.5.5,0,0,1,.5.5A.5.5,0,0,1,6.1.5Z",
    transform: "translate(157.981 228.423)",
    fill: "#377EF3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectBlue);
export default __webpack_public_path__ + "static/media/icon_project_blue.abee1b632c59ab41f853c45eb393c9de.svg";
export { ForwardRef as ReactComponent };